import {Avatar, Badge, Button, Input} from 'antd'
import {referral_getReferralCode_Api} from 'apis'
import {UpdateReferalCode} from 'components/UpdateReferalCode'
import copyToClipboard from 'copy-to-clipboard'
import {ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import useAsync from 'modules/asyncCache/useAsync'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useLayoutEffect} from 'react'
import {Link} from 'react-router-dom'
import useToggle from 'react-use/lib/useToggle'
import LoadingPage from 'views/LoadingPage'
import ServerContext from 'views/Server/ServerContext'
import {RiSignalTowerFill} from "react-icons/ri";
import getLinkToDetail from 'helpers/getLinkToDetail'
import {parseDayjs} from "../../helpers/datetimeHelpers";

const Invite = ({item: i, showTitle = true}) => {
    const t = useTranslate()
    const {item} = useContext(ServerContext)
    const [isToggle, toggle] = useToggle()
    const [isToggleCopy2, toggleCopy2] = useToggle(false)
    const {response} = useAsync({
        apiInfo: referral_getReferralCode_Api,
        values: {
            target_id: (i || item).id,
            target_type: (i || item)._type
        }
    })
    useLayoutEffect(() => {
        let timeout
        if (isToggle) {
            timeout = setTimeout(
                () => toggle(false),
                800
            )
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout)
            }
        }
    }, [isToggle, toggle])

    useLayoutEffect(() => {
        let timeout
        if (isToggleCopy2) {
            timeout = setTimeout(
                () => toggleCopy2(false),
                800
            )
        }
        return () => {
            if (timeout) {
                clearTimeout(timeout)
            }
        }
    }, [isToggleCopy2, toggleCopy2])

    const data = _.get(response, 'data')

    if (!data) return <LoadingPage/>

    const inviteLink = ROOT_URL + '/invite/' + _.get(data, 'referral_code')

    const timeout = parseDayjs(_.get(data, 'created')).add(_.get(data, 'timeout'), 'second').fromNow()

    return (
        <div className="flex flex-col p-5 gap-5">
            {showTitle && (
                <div className="font-bold text-center text-xl text-color-000 uppercase mb-6">
                    {t('Invite your friends to this page')}
                </div>
            )}
            <UpdateReferalCode referral={data}/>
            <div className="p-3 w-full flex items-center gap-4 rounded-lg border border-primary-500">
                <Avatar
                    size={80}
                    icon={<RiSignalTowerFill size={60} className="text-primary-600"/>}
                    className="flex flex-center bg-primary-50 rounded-lg"
                />
                <div className="flex flex-col gap-1">
                    <Link
                        to={getLinkToDetail(item)}
                        className="font-bold text-lg text-primary-500 no-underline">
                        {item?.title}
                    </Link>
                    <div
                        style={{
                            justifySelf: 'flex-end',
                            display: 'flex'
                        }}>
                        <div className="flex items-center mr-3 rounded-full py-1">
                            <Badge
                                color="#c9c9c9"
                                text={
                                    <span className="space-x-1 font-medium text-sm text-color-300 italic">
                                    {item?.total_members}{' '}{t('members')}
                                </span>
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
            {item.description && (
                <div className="flex flex-col">
                    <div className="flex-1 font-medium text-sm text-color-300 uppercase">
                        {t('introduce')}
                    </div>
                    <div className="text-xs text-color-300 font-light italic">
                        {item?.description}
                    </div>
                </div>
            )}
            <div className="pb-3">
                <div className="mb-1 font-semibold text-sm text-color-000 italic">
                    {t('Send invitation to join the channel to your friends, by sending a copy of the page link below')}
                </div>
                <div
                    onClick={() => {
                        copyToClipboard(inviteLink)
                        toggle(true)
                    }}>
                    <Input
                        value={inviteLink}
                        className="rounded-md"
                        suffix={
                            <Button
                                ghost={isToggle}
                                size="small"
                                className="button-rounded-full flex flex-center italic"
                                type="primary">
                            <span className="text-xs font-medium px-2">
                                {t(isToggle ? 'copied' : 'copy')}
                            </span>
                            </Button>
                        }
                    />
                </div>
                <div className="mt-1 mb-2 text-xs text-color-300 italic">
                    {_.get(data, 'timeout', 0) === 0 || _.get(data, 'no_expired', 0) === 1
                        ? t('Permanent link')
                        : `${t('your invite link expires')} ${timeout}`
                    }
                </div>
                <div className="pt-5">
                    <div className="mb-1 font-semibold text-sm text-color-000 italic">
                        {t('Copy and share the page link below to your friends. For everyone you need to share easily access and follow this channel')}
                    </div>
                    <div
                        onClick={() => {
                            copyToClipboard(
                                ROOT_URL +
                                getLinkToDetail(
                                    item
                                )
                            )
                            toggleCopy2(true)
                        }}>
                        <Input
                            className="rounded-md"
                            value={ROOT_URL + getLinkToDetail(item)}
                            suffix={
                                <Button
                                    ghost={isToggleCopy2}
                                    size="small"
                                    className="button-rounded-full flex flex-center italic"
                                    type="primary">
                                  <span className="text-xs font-medium px-2">
                                      {t(isToggleCopy2 ? 'copied' : 'copy')}
                                  </span>
                                </Button>
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Invite



